// eslint-disable-next-line import/no-cycle
import AuthService from "../../AuthService";

const membershipRate = {
  getMembershipRate(page) {
    return AuthService.get(`/membership/membership_rates?page=${page}`);
  },
  showMembershipRate(id) {
    return AuthService.get(`/membership/membership_rates/${id}`);
  },
  createMembershipRate(data) {
    return AuthService.post("/membership/membership_rates", data);
  },
  updateMembershipRate(id, data) {
    return AuthService.put(`/membership/membership_rates/${id}`, data);
  },
  deleteMembershipRate(id) {
    return AuthService.delete(`/membership/membership_rates/${id}`);
  }
};
export default membershipRate;
